export enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
  NAVY = 'navy',
  PERSONAL = 'personal',
  PERSONAL_FOREST_GREEN = 'personal--forest-green',
  PERSONAL_BRIGHT_GREEN = 'personal--bright-green',
  PERSONAL_DARK = 'personal--dark',
}

export type ThemeLight = 'light';
export type ThemeDark = 'dark';
export type ThemeNavy = 'navy';
export type ThemePersonal = 'personal';
export type ThemePersonalForestGreen = 'personal--forest-green';
export type ThemePersonalBrightGreen = 'personal--bright-green';
export type ThemePersonalDark = 'personal--dark';

export type ThemeType =
  | ThemeLight
  | ThemeDark
  | ThemeNavy
  | ThemePersonal
  | ThemePersonalForestGreen
  | ThemePersonalBrightGreen
  | ThemePersonalDark;

export const modernThemes = new Set<ThemeType>([
  'personal',
  'personal--forest-green',
  'personal--bright-green',
  'personal--dark',
]);

export const getThemeClassName = (theme: ThemeType) => `np-theme-${theme}`;
